import useAsyncData from "../../../../hooks/use-async-data";
import billingService from "../../billings.service";
import BillingsOrderForwardBillingsList from "./billings-order-forward-billings-list";
import BillingsOrderForwardBillingsListParams from "./billings-order-forward-billings-list-params";

const useOrderForwardBillingsList = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderForwardBillingsList>({
      data: [],
      totalCount: 0,
    });

  const load = async (
    params: BillingsOrderForwardBillingsListParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const billingsOrderForwardListing =
        await billingService.getOrderForwardBillingsList(params, signal);

      setData(billingsOrderForwardListing);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderForwardBillingsList;
